module.exports = __webpack_public_path__ + "img/New-Members.6fec9f36.png";